import * as ROUTES from 'Routes'
import { ROOT_URL } from 'gatsby-env-variables'
import { useContext, useState } from 'react'
import { navigate } from 'gatsby'
import If from '@mobi/components/If'
import Text from 'components/Text'
import Button from 'components/Button'
import router from 'utils/router'
import useMediaQuery from 'hooks/useMediaQuery'
import { ThemeContext } from 'modules/Theme'
import analytics from '@mobi/libraries/analytics'
import { handlePerformanceMark } from 'utils/trackings/newRelicEvents'
import RecoveryLogo from '/static/icons/logo-recovery.svg'
import ItauLogo from '/static/icons/logo-itau.svg'
import LPCloseIcon from '/static/svg/icon-lp-close.svg'
import LPMenuIcon from '/static/svg/icon-lp-menu.svg'

import './Header.scss'
import * as classNames from 'classnames'

const Header = () => {
  const { theme } = useContext(ThemeContext)

  const [isOpen, setIsOpen] = useState(false)

  const isRecoveryOrigin = theme === 'recovery'

  const isNotMobile = useMediaQuery('notMobile')

  const buttonClickTrack = ({
    ev,
    hasElementClicked = true,
    hasButtonClick = true,
  }) => {
    if (hasElementClicked) {
      analytics.track('elementClicked', {
        location: ev.currentTarget.dataset.trackingLocation,
        position: ev.currentTarget.dataset.trackingPosition,
        elementType: ev.currentTarget.dataset.trackingElement,
        text: ev.currentTarget.textContent,
        htmlId: ev.currentTarget.dataset.unique,
        actionOutcome: ev.currentTarget.dataset.trackingActionoutcome,
        outboundUrl: ev.currentTarget.dataset.trackingOutboundurl,
      })
    }

    if (hasButtonClick) {
      analytics.track('gaButtonClick', {
        id: ev.currentTarget.dataset.unique,
        text: ev.currentTarget.textContent,
      })
    }

    analytics.track('formStarted')
  }

  const handleMenu = (ev) => {
    setIsOpen(!isOpen)

    analytics.track('elementClicked', {
      location: ev.currentTarget.dataset.trackingLocation,
      position: ev.currentTarget.dataset.trackingPosition,
      elementType: ev.currentTarget.dataset.trackingElement,
      text: ev.currentTarget.ariaLabel,
      htmlId: ev.currentTarget.dataset.unique,
      actionOutcome: ev.currentTarget.dataset.trackingActionoutcome,
      outboundUrl: ev.currentTarget.dataset.trackingOutboundurl,
    })
  }

  const renderOptions = (screen = 'mobile') => {
    return (
      <div
        className={classNames('header-buttons', `header-buttons--${screen}`)}
        data-test="header-buttons"
      >
        <a
          href="/registro"
          onClick={(ev) => {
            ev.preventDefault()
            buttonClickTrack({ ev })
            handlePerformanceMark(ROUTES.register.pageName)
            analytics.track('segmentButtonClick', {
              name: 'SegundaViaBoleto',
              id: 'd4d31dc1-7161-470a-99b2-0a0383f7e9a8',
            })
            navigate('/registro', {
              state: {
                title:
                  'Para consultar seus acordos vigentes, precisamos das seguintes informações:',
              },
            })
          }}
          data-unique="d4d31dc1-7161-470a-99b2-0a0383f7e9a8"
          data-tracking-location="header"
          data-tracking-position="header-menu"
          data-tracking-actionoutcome="redirect"
          data-tracking-element="link"
          className="header-buttons__link"
        >
          2ª via de boleto
        </a>
        <a
          href="#DuvidasFrequentes"
          onClick={(ev) => {
            analytics.track('segmentButtonClick', {
              name: 'DuvidasFrequentes',
              id: 'bd5f9539-7ab9-4d2c-addd-ebf5f2f5deb9',
            })
            buttonClickTrack({ ev })
          }}
          data-unique="bd5f9539-7ab9-4d2c-addd-ebf5f2f5deb9"
          data-tracking-location="header"
          data-tracking-position="header-menu"
          data-tracking-actionoutcome="redirect"
          data-tracking-element="link"
          className="header-buttons__link"
        >
          Dúvidas frequentes
        </a>
        <Button
          className="header-buttons__negotiate-button"
          data-unique="dead1e09-c6f8-47af-81b0-b83327aba12e"
          data-tracking-location="header"
          data-tracking-position="header-menu"
          data-tracking-actionoutcome="redirect"
          data-tracking-element="button"
          data-tracking-outboundurl={`${ROOT_URL}${ROUTES.register.path}`}
          onClick={(ev) => {
            analytics.track('segmentButtonClick', {
              name: 'Negociar',
              id: 'dead1e09-c6f8-47af-81b0-b83327aba12e',
            })
            buttonClickTrack({
              ev,
              hasElementClicked: false,
              hasButtonClick: false,
            })
            handlePerformanceMark(ROUTES.register.pageName)
            navigate(ROUTES.register.path, {
              state: {
                source_url: location.href,
                mp_uuid: router.getQueryString('mp_uuid'),
              },
            })
          }}
        >
          Renegociar
        </Button>
      </div>
    )
  }

  return (
    <div className="header-container">
      <div className="header-content">
        <div className="header-content__logos">
          <RecoveryLogo
            alt="Logo oficial da Recovery"
            width={isNotMobile ? 155 : 104}
            height={isNotMobile ? 28 : 20}
          />

          <If
            condition={isRecoveryOrigin}
            renderIf={
              <span
                className="header-banner-itau"
                aria-label="Uma empresa Itaú"
                role="banner"
              >
                <Text p aria-hidden="true">
                  Uma empresa
                </Text>

                <ItauLogo
                  width={isNotMobile ? 35 : 25}
                  height={isNotMobile ? 34 : 24}
                  alt="Logo Itaú"
                  aria-hidden="true"
                />
              </span>
            }
          />
        </div>

        {renderOptions('desktop')}

        <button
          className="icon-menu"
          onClick={handleMenu}
          aria-haspopup="true"
          aria-controls="menu"
          aria-expanded={isOpen}
          aria-label={`${isOpen ? 'Fechar' : 'Abrir'} menu`}
          data-tracking-location="header"
          data-tracking-position="header-menu-mobile"
          data-tracking-actionoutcome="clique"
          data-tracking-element="button"
        >
          <If
            condition={isOpen}
            renderIf={<LPCloseIcon />}
            renderElse={<LPMenuIcon />}
          />
        </button>
      </div>
      {isOpen && renderOptions('mobile')}
    </div>
  )
}

export default Header
